import template from './uimessages.html';
import './uimessages.scss';

class UIMessagesController {
  closeNotification(notification) {
    this.onNotificationCloseRequest({ notification });
  }
  closeAlert() {
    this.onAlertAction();
  }
  cancelConfirm() {
    this.confirmAction(false);
  }
  acceptConfirm() {
    this.confirmAction(true);
  }
  confirmAction(value) {
    this.onConfirmAction({ value });
  }
}

export default {
  controller: UIMessagesController,
  template,
  bindings: {
    notifications: '<',
    onNotificationCloseRequest: '&',
    showAlert: '<',
    alertInfo: '<',
    onAlertAction: '&',
    showConfirm: '<',
    confirmInfo: '<',
    onConfirmAction: '&',
  },
};
